/**
 * Created by Wang.Qiong on 2021/9/11.
 */
import React, { useState, useEffect } from 'react'
import { Modal, Input, Button, Table, message, Empty, Form } from 'antd';
import { getQiNiuToken } from '../../../utils/api'
import '../new.scss'
const { TextArea } = Input;
function Particulars(props) {
    useEffect(() => {
        // console.log('**************');
        // console.log(props.particularsContent);

    }, [props])
    return (
        <div >
            <Modal
                className='changeNew'
                title="详情"
                centered
                visible={props.particularsVisible}
                onCancel={() => props.handleParticularsVisible(false)}
                width={900}
                height={400}
                footer={[
                    <Button onClick={() => props.handleParticularsVisible(false)} style={{ background: '#0093D8', color: '#fff' }}>
                        取消
                    </Button>
                ]}
            >

                <h1>{props.particularsContent?.title}</h1>
                <h4 style={{ padding: '20px 0px' }}>{props.particularsContent?.subtitle}</h4>
                <div className='new_content' dangerouslySetInnerHTML={{ __html: props.particularsContent?.context }}></div>
            </Modal>

        </div>
    )

}
export default Particulars;
